/**
 * ดึงรายการอัปเดตระบบจาก Management API (ใช้ API_SECRET)
 */

const getManagementApiSecret = () => process.env.REACT_APP_MANAGEMENT_API_SECRET || ''
const MANAGEMENT_API = (window as any).REACT_APP_MANAGEMENT_API || 'https://customer.cliniter.com/api'

export type SystemUpdateSectionType = 'NEW_FEATURE' | 'FUNCTION_UPDATE' | 'BUG_FIXES'

export interface SystemUpdateSection {
  title: string
  content: string
  type?: SystemUpdateSectionType
}

export interface SystemUpdateItem {
  updateId: number
  updateDate: string
  startTime: string
  endTime: string
  /** หัวข้อหลัก (แสดงแทนหรือร่วมกับวันที่) */
  mainTitle?: string | null
  newFeatures: string | null
  improvements: string | null
  bugFixes: string | null
  /** หัวข้อและเนื้อหาแต่ละหัวข้อ (จาก management) */
  sections?: SystemUpdateSection[] | null
  status?: string
  createdAt?: string
  updatedAt?: string
}

export async function fetchActiveSystemUpdates(): Promise<SystemUpdateItem[]> {
  try {
    const apiSecret = getManagementApiSecret()
    const headers: HeadersInit = {
      'Content-Type': 'application/json',
      ...(apiSecret && { Authorization: `Bearer ${apiSecret}` }),
    }
    const resp = await fetch(`${MANAGEMENT_API}/system-updates/active`, { headers })
    if (!resp.ok) return []
    const json = await resp.json()
    const data = json?.data ?? json
    const list = Array.isArray(data) ? data : []
    return list
  } catch {
    return []
  }
}
